function TermsOfUse() {
  return (
    <div className="container py-5 px-3">
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <h1 className="fw-bold mb-4">Terms of Use</h1>
          <p className="text-muted">Effective Date: [01/01/2024]</p>

          <p>
            These Terms of Use govern your access to and use of the Investify
            platform. By creating an account or using the Investify application,
            you agree to comply with these terms.
          </p>

          <h4 className="mt-4">1. About Investify</h4>
          <p>
            Investify is a digital platform that allows users to invest in
            fractional shares of real estate projects. The platform provides
            access to investment opportunities but does not guarantee profits or
            investment returns.
          </p>

          <h4 className="mt-4">2. Eligibility</h4>
          <p>To use Investify you must:</p>
          <ul>
            <li>Be at least 18 years old</li>
            <li>Provide accurate and truthful information</li>
            <li>Comply with all applicable laws and regulations</li>
          </ul>

          <h4 className="mt-4">3. Investment Risk</h4>
          <p>
            Real estate investments carry risk. Property values may increase or
            decrease and returns are not guaranteed. Users are responsible for
            making their own investment decisions when using the platform.
          </p>

          <h4 className="mt-4">4. User Responsibilities</h4>
          <p>Users agree to:</p>
          <ul>
            <li>Provide accurate account information</li>
            <li>Maintain the confidentiality of login credentials</li>
            <li>Use the platform only for lawful purposes</li>
          </ul>

          <h4 className="mt-4">5. Platform Availability</h4>
          <p>
            We strive to maintain uninterrupted service but cannot guarantee
            continuous availability. The platform may occasionally be
            unavailable due to maintenance, updates, or technical issues.
          </p>

          <h4 className="mt-4">6. Fees</h4>
          <p>
            Investify may charge certain service or transaction fees. Any
            applicable fees will be disclosed before completing transactions on
            the platform.
          </p>

          <h4 className="mt-4">7. Intellectual Property</h4>
          <p>
            All content, branding, software, and design elements of the
            Investify platform are owned by Investify or its licensors. Users
            may not copy, distribute, or reproduce any content without
            permission.
          </p>

          <h4 className="mt-4">8. Account Termination</h4>
          <p>
            Investify reserves the right to suspend or terminate accounts that
            violate these terms or engage in fraudulent or illegal activity.
          </p>

          <h4 className="mt-4">9. Limitation of Liability</h4>
          <p>
            Investify shall not be liable for any losses resulting from market
            conditions, investment decisions, or third-party service failures.
            Use of the platform is at the user's own risk.
          </p>

          <h4 className="mt-4">10. Changes to These Terms</h4>
          <p>
            We may update these Terms of Use from time to time. Continued use of
            the platform after changes are posted constitutes acceptance of the
            updated terms.
          </p>

          <h4 className="mt-4">11. Contact Information</h4>
          <p>If you have questions about these Terms of Use, contact us:</p>

          <p>
            <strong>Email:</strong> contact@codecamp.ng <br />
            <strong>Company:</strong> CodeCamp Technologies Ltd <br />
            <strong>Location:</strong> Lagos, Nigeria
          </p>
        </div>
      </div>
    </div>
  );
}

export default TermsOfUse;
